import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesMenu/groups/styles.scss';export default {
  "title": "_title_133t5_1",
  "buttonSelection": "_buttonSelection_133t5_8",
  "addGroupIcon": "_addGroupIcon_133t5_15",
  "top": "_top_133t5_21",
  "groupPlaceholder": "_groupPlaceholder_133t5_27"
};